/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum ElliotType {
    IMPUTER = 'Imputer',
    EXTRACTOR = 'Extractor',
    REGULATOR = 'Regulator',
    BENEFICIARY = 'Beneficiary',
    AFFECTEE = 'Affectee',
    INFLUENCER = 'Influencer',
    OTHER = 'Other',
}
